import { useContext, useEffect, useState } from 'react'
import { Form, Col, Row, Button, Alert } from 'react-bootstrap'
import axios from 'axios';
import { Menu, MenuItem, Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { checkError, fetchTypeAheadTerms, isObjectEmpty } from '../utils/utils';
import { api } from "../services/config"
import { ProjectContext } from '../screens/ProjectScreen';
import { useOutletContext } from 'react-router-dom';

function AddSC({ semantic, setSemantic, setAddSCIsClose }) {
    // semantic: used when opening the popup to edit a semantic class by providing its data
    const {
        projectState, setProjectState,
        termData,
        setTreeState,
        headers,
    } = useContext(ProjectContext);
    const { profileState } = useOutletContext();
    const { projectRole: { projectId } } = profileState

    let term
    if (projectState.addSCTermIsOpen === true) {
        term = (termData === null || termData === undefined) ? '' : [termData]
    } else if (semantic) {
        term = [semantic.term]
    }

    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);

    const [termVedette, setTermVedette] = useState(term)
    const [hypernymSC, setHypernymSC] = useState([])
    const [associatedSC, setAssociatedSC] = useState([])

    const [terms, setTerms] = useState([])
    const [termsHsc, setTermsHsc] = useState([])
    const [termsAsc, setTermsAsc] = useState([])

    const [query, setQuery] = useState({
        'surface_regex': "",
        'sort': (["reference"]),
        "is_vedette": false
    })

    const [queryAsc, setQueryAsc] = useState({
        'surface_regex': "",
        'sort': (["reference"]),
        "is_vedette": true
    })

    const [queryHsc, setQueryHsc] = useState({
        'surface_regex': "",
        'sort': (["reference"]),
        "is_vedette": true
    })
    const [loading, setLoading] = useState(false)

    const [semantic_hypernyms, setSemantic_hypernyms] = useState();
    const [semantic_associated, setSemantic_associated] = useState();

    const [validated, setValidated] = useState(false);
    const [checked, setChecked] = useState(false)

    function fetchSCs(updateVariable, type) {
        const config = {
            headers
        };

        if (type === "hyper") {
            axios.put(
                `${api.project}${projectId}/sc/`,
                { 'ids': semantic.hypernyms.map(item => item.id) },
                config
            ).then(response => {
                updateVariable(response.data.classes.map(sc => sc.term))
            });
        } else if (type === "assoc") {
            axios.put(
                `${api.project}${projectId}/sc/`,
                { 'ids': semantic.associated.map(asc => asc.id) },
                config
            ).then(response => {
                updateVariable(response.data.classes.map(sc => sc.term))
            });
        }
    }

    const tVHandleInputChange = query => {
        setTerms([])
        setQuery({
            'surface_regex': query ? `(^${query})` : "",
            'sort': (["reference"]),
            "is_vedette": false
        });
    };

    const sHCHandleInputChange = query => {
        setTermsHsc([])
        setQueryHsc({
            'surface_regex': query ? `(^${query})` : "",
            'sort': (["reference"]),
            "is_vedette": true,
        });
    };

    const sACHandleInputChange = query => {
        setTermsAsc([])
        setQueryAsc({
            'surface_regex': query ? `(^${query})` : "",
            'sort': (["reference"]),
            "is_vedette": true,
        });
    };

    useEffect(() => {
        if (semantic?.hypernyms?.length > 0 && (!semantic_hypernyms)) {
            fetchSCs(setSemantic_hypernyms, "hyper")
        }
        if (semantic?.associated?.length > 0 && (!semantic_associated)) {
            fetchSCs(setSemantic_associated, "assoc")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        setLoading(false)
        if (query !== undefined && query.length !== 0) fetchTypeAheadTerms(projectId, query, setTerms, setLoading)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    useEffect(() => {
        setLoading(false)
        if (queryHsc !== undefined && queryHsc.length !== 0) fetchTypeAheadTerms(projectId, queryHsc, setTermsHsc, setLoading)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryHsc])

    useEffect(() => {
        setLoading(false)
        if (queryAsc !== undefined && queryAsc.length !== 0) fetchTypeAheadTerms(projectId, queryAsc, setTermsAsc, setLoading)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryAsc])

    const onShowSuccessMessage = () => {
        setShowSuccess(true)
        window.setTimeout(() => {
            setShowSuccess(false)
            toggleAddSCTermPopup()
            toggleAddSCPopup()
            if (setAddSCIsClose) setAddSCIsClose(false)
        }, 500)
    };

    const onShowErrorMessage = () => {
        setShowError(true)
        window.setTimeout(() => {
            setShowError(false)
        }, 2000)
    };

    const formHandleSubmit = event => {
        event.preventDefault();
        const data = {
            bulk: false,
            terms: termVedette?.[0] ? [Number(termVedette[0].id)] : [],
            hypernyms: hypernymSC.map((i) => i.vedette_class),
            associated: associatedSC.map((i) => i.vedette_class),
        };
        setChecked(true);
        if (termVedette?.[0] && queryAsc.surface_regex.length === 0 && queryHsc.surface_regex.length === 0) {
            setValidated(true);
            setChecked(false);
            axios.post(api.project + projectId + '/sc/', data, {
                headers
            })
                .then(checkError)
                .then(() => {
                    onShowSuccessMessage();
                    const updatedSemantics = data.hypernyms.length > 0 ? data.hypernyms : [0]
                    setTreeState({
                        item: `terms-${termVedette[0].id}`,
                        updatedSemantics: [...updatedSemantics, ...data.associated],
                    });
                })
                .catch(() => {
                    onShowErrorMessage();
                })
        }

        if (termVedette !== undefined && termVedette[0] !== undefined && queryAsc.surface_regex.length === 0 && queryHsc.surface_regex.length === 0) {
            setTermVedette()
            setAssociatedSC([])
            setHypernymSC([])
        }
    }

    const formHandleUpdate = event => {
        event.preventDefault();
        setChecked(true);
        if (termVedette?.[0] && queryAsc.surface_regex.length === 0 && queryHsc.surface_regex.length === 0) {
            const data = {
                term: termVedette?.[0]?.id,
                hypernyms: (hypernymSC.length !== 0)
                    ? hypernymSC?.map((i) => i.vedette_class)
                    : semantic_hypernyms?.map((i) => i.vedette_class) || [],
                associated: (associatedSC.length !== 0)
                    ? associatedSC?.map((i) => i.vedette_class)
                    : semantic_associated?.map((i) => i.vedette_class) || [],
            };

            setValidated(true);
            setChecked(false);
            axios.put(`${api.project}${projectId}/sc/${semantic.id}/`, data, {
                headers
            })
                .then(checkError)
                .then((newData) => {
                    setSemantic && setSemantic(newData)
                    onShowSuccessMessage();

                    const addedInSemantics = data.hypernyms.filter(id => !(semantic.hypernyms.map(hypernym => hypernym.id)).includes(id));
                    const deletedFromSamantics = semantic.hypernyms.map(hypernym => hypernym.id).filter(id => !data.hypernyms.includes(id));
                    const updatedSemantics = [...addedInSemantics, ...deletedFromSamantics]
                    const addedAssociated = data.associated.filter(id => !(semantic.associated.map(associated => associated.id)).includes(id));
                    const deletedAssociated = semantic.associated.map(associated => associated.id).filter(id => !data.associated.includes(id));
                    const updatedAssociated = [...addedAssociated, ...deletedAssociated]

                    // Update root if we remove all hypernyms from a class
                    // or if we add hypernyms to a class that had none
                    const updatedRoot = (
                        (deletedFromSamantics.length > 0 && data.hypernyms.length === 0) ||
                        (semantic.hypernyms.length === 0 && data.hypernyms.length > 0)
                    ) ? [0] : []

                    setTreeState({
                        item: `terms-${termVedette[0].id}-${addedInSemantics}-${deletedFromSamantics}`,
                        updatedSemantics: [
                            ...updatedSemantics,
                            ...updatedAssociated,
                            ...(updatedAssociated.length > 0 ? [semantic.id] : []),
                            ...updatedRoot
                        ],
                    });
                })
                .catch(() => {
                    onShowErrorMessage();
                })
        }
    }

    const onChangeAssociatedSC = (data) => {
        setAssociatedSC(data)
        if (semantic) setSemantic_associated(data)
    }

    const onChangeHypernymSC = (data) => {
        setHypernymSC(data)
        if (semantic) setSemantic_hypernyms(data)
    }

    const toggleAddSCPopup = () => {
        setProjectState(projectState => ({ ...projectState, addSCIsOpen: false, refresh: !projectState?.refresh }))
    }

    const toggleAddSCTermPopup = () => {
        setProjectState(projectState => ({ ...projectState, addSCTermIsOpen: false, refresh: !projectState?.refresh }))
    }


    return (
        <div>
            <Alert className="mx-5" variant="success" show={showSuccess} >
                Classe sémantique {!semantic ? "ajouté" : "éditée"} avec succès
            </Alert>
            <Alert className="mx-5" variant="danger" show={showError} >
                Une erreur s'est produite lors de la création classe sémantique
            </Alert>
            <Form className="mt-3 mx-5" noValidate validated={validated} >
                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        Terme vedette <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Col sm="8" xs="12">
                        <Typeahead
                            className={checked && (!termVedette?.[0]) ? "is-invalid" : ""}
                            isInvalid={checked && (!termVedette?.[0])}
                            id="search-term"
                            onChange={(data) => { setTermVedette(data); setTerms([]) }}
                            labelKey="reference"
                            renderMenu={(results, menuProps) => (
                                <Menu {...menuProps}>
                                    {results.map((result, index) => (
                                        <MenuItem option={result} position={index}>
                                            <span>
                                                {result.reference}
                                            </span>
                                            <span className="opacity-50 f-s-13 ">
                                                {result?.form?.source?.label}
                                            </span>
                                        </MenuItem>
                                    ))}
                                </Menu>
                            )}
                            emptyLabel={!(query !== undefined && query.length !== 0) ? "Commencer à saisir..." : !loading ? "Recherche..." : "Aucune correspondance trouvée"}
                            options={(query !== undefined && query.length !== 0) ? terms : []}
                            onInputChange={tVHandleInputChange}
                            placeholder="Sélectionnez un terme..."
                            selected={termVedette || []}
                        />
                        <Form.Control.Feedback type="invalid">{(query && query.surface_regex.length > 0) ? "Veuillez renseigner une valeur existante." : "Veuillez renseigner ce champ."}</Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        Hyperonyme
                    </Form.Label>
                    <Col sm="8" xs="12">
                        <Typeahead
                            selected={isObjectEmpty(hypernymSC) && semantic_hypernyms ? semantic_hypernyms : hypernymSC}
                            isInvalid={checked && (queryHsc.surface_regex.length !== 0)}
                            className={checked && (queryHsc.surface_regex.length !== 0) ? "is-invalid" : ""}
                            id="search-class"
                            onChange={(data) => { onChangeHypernymSC(data); setTerms([]); setQueryHsc({ ...queryHsc, surface_regex: "" }) }}
                            labelKey="reference"
                            renderMenu={(results, menuProps) => (
                                <Menu {...menuProps}>
                                    {results.map((result, index) => (
                                        <MenuItem option={result} position={index}>
                                            <span>
                                                {result.reference}
                                            </span>
                                            <span className="opacity-50 f-s-13 ">
                                                {result?.form?.source?.label}
                                            </span>
                                        </MenuItem>
                                    ))}
                                </Menu>
                            )}
                            multiple
                            emptyLabel={!(queryHsc !== undefined && queryHsc.length !== 0) ? "Commencer à saisir..." : !loading ? "Recherche..." : "Aucune correspondance trouvée"}
                            options={(queryHsc !== undefined && queryHsc.length !== 0) ? termsHsc : []}
                            onInputChange={sHCHandleInputChange}
                            placeholder="Sélectionnez une classe..."
                            style={{ flex: 1 }}
                        />
                        <Form.Control.Feedback type="invalid"> Veuillez renseigner une valeur existante.</Form.Control.Feedback>
                    </Col>

                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        Classes sémantiques associées
                    </Form.Label>
                    <Col sm="8" xs="12">
                        <Typeahead
                            selected={isObjectEmpty(associatedSC) && semantic_associated ? semantic_associated : associatedSC}
                            isInvalid={checked && (queryAsc.surface_regex.length !== 0)}
                            className={checked && (queryAsc.surface_regex.length !== 0) ? "is-invalid" : ""}
                            id="basic-example"
                            onChange={(data) => { onChangeAssociatedSC(data); setTerms([]); setQueryAsc({ ...queryAsc, surface_regex: "" }) }}
                            labelKey="reference"
                            renderMenu={(results, menuProps) => (
                                <Menu {...menuProps}>
                                    {results.map((result, index) => (
                                        <MenuItem option={result} position={index}>
                                            <span>
                                                {result.reference}
                                            </span>
                                            <span className="opacity-50 f-s-13 ">
                                                {result?.form?.source?.label}
                                            </span>
                                        </MenuItem>
                                    ))}
                                </Menu>
                            )}
                            multiple
                            emptyLabel={!(queryAsc !== undefined && queryAsc.length !== 0) ? "Commencer à saisir..." : !loading ? "Recherche..." : "Aucune correspondance trouvée"}
                            options={(queryAsc !== undefined && queryAsc.length !== 0) ? termsAsc : []}
                            onInputChange={sACHandleInputChange}
                            placeholder="Sélectionnez une classe..."
                            style={{ flex: 1 }}
                        />
                        <Form.Control.Feedback type="invalid"> Veuillez renseigner une valeur existante.</Form.Control.Feedback>
                    </Col>

                </Form.Group>
                <div className="text-center">
                    <Button type="submit" onClick={!semantic ? formHandleSubmit : formHandleUpdate}>
                        {!semantic ? "Ajouter" : "Modifier"} la classe
                    </Button>
                </div>
            </Form>
        </div>
    )
}

export default AddSC